var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.status
    ? _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u(
            [
              {
                key: "activator",
                fn: function ({ on }) {
                  return [
                    _c(
                      "v-icon",
                      _vm._g(
                        { attrs: { small: "", color: _vm.status.color } },
                        on
                      ),
                      [_vm._v(_vm._s(_vm.status.icon))]
                    ),
                  ]
                },
              },
            ],
            null,
            false,
            512741735
          ),
        },
        [
          _c("span", [
            _vm._v(_vm._s(_vm.status.name)),
            _vm.payslip.email_to
              ? _c("span", [_vm._v(" (" + _vm._s(_vm.payslip.email_to) + ")")])
              : _vm._e(),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }